<div
  class="page-header row pt-0"
  [ngClass]="{ close_icon: navService.collapseSidebar }"
  [ngStyle]="{ display: hideScrollNavService.headerFixed ? 'none' : 'flex' }"
>
  <div class="d-flex align-items-center justify-content-between w-100">
    <div>
      <img class="img-fluid" src="assets/svg/main-logo.svg" alt="" />
    </div>
    <div class="d-flex align-items-center justify-content-center gap-2">
      <button class="btn btn-secondary rounden-circle position-relative" (click)="goToAlerts()">
        <i class="fa fa-bell"></i>
        @if (notificationCount > 0) {
          <span class="notification-badge d-flex align-items-center justify-content-center">{{ notificationCount > 9 ? '9+' : notificationCount }}</span>
        }
      </button>
      @if (isAdmin()) {
        <button class="btn btn-primary rounden-circle" (click)="goToCreateUser()">
          <i class="fa fa-plus"></i>
        </button>
      }
      <div class="position-relative" #profileMenu>
        <button class="btn btn-secondary rounden-circle" (click)="toggleProfileMenu($event)">
          <i class="fa fa-bars"></i>
        </button>
        <ul class="profile-dropdown onhover-show-div" [class.active]="isProfileMenuOpen">
          <li (click)="onProfileClick()">
            <a>
              <i class="fa fa-user"></i>
              <span translate>{{ 'pagetitle.profile' }}</span>
            </a>
          </li>
          <li (click)="onLogoutClick()">
            <a>
              <i class="fa fa-sign-out"></i>
              <span translate>{{ 'buttons.logout' }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <app-breadcrumb class="mt-2 mb-0"></app-breadcrumb>
</div>
